define('home/views/EmailVerificationAlertView',[
    'underscore',
    'backbone-marionette',

    'core/mixins/withEmailVerifyLink',

    'home/models/Session',

    'home/templates/emailVerificationAlert',
], function (
    _,
    Marionette,

    withEmailVerifyLink,

    Session,

    emailVerificationAlertTemplate
) {
    'use strict';

    var EmailVerificationAlertView = Marionette.ItemView.extend({
        template: emailVerificationAlertTemplate,

        templateHelpers: function () {
            return {
                user: this.session.user.toJSON(),
                shouldShowEmailVerificationAlert: this.shouldShowEmailVerificationAlert(),
            };
        },

        initialize: function () {
            this.session = Session.get();
            this.session.loadPromise().then(_.bind(this.render, this));
        },

        /**
         * Determines to whom to show the email verification alert.
         */
        shouldShowEmailVerificationAlert: function () {
            return this.session.isLoggedIn() &&
              !this.session.user.get('isVerified') &&
              this.session.user.get('homeFeedOnboardingComplete');
        },

    });

    withEmailVerifyLink.call(EmailVerificationAlertView.prototype);

    return EmailVerificationAlertView;
});

